import { Box, Radio, SxProps, Typography } from '@mui/material';
import { FC } from 'react';
import { ContactType } from '~/api/types';
import EmailIcon from '@mui/icons-material/MailOutline';
import WhatsappIcon from '@mui/icons-material/WhatsApp';

const ButtonSx: SxProps = {
  'my': 1,
  'py': 2,
  'px': 3,
  'mx': 'auto',
  'backgroundColor': 'grey.100',
  'display': 'flex',
  'justifyContent': 'space-between',
  'alignItems': 'center',
  'cursor': 'pointer',
  '&:hover': {
    backgroundColor: 'grey.200',
  },
};

const LabelSx: SxProps = {
  textAlign: 'left',
  display: 'flex',
  alignItems: 'center',
  maxWidth: 'calc(100% - 50px)',
};

const TitleSx = {
  ml: 2,
  wordWrap: 'break-word',
  overflow: 'hidden',
};

export const ContactSelectionButton: FC<ContactSelectionButtonProps> = ({ contactType, label, onClick, selected }) => {
  const Icon = contactType === 'email' ? EmailIcon : WhatsappIcon;

  return (
    <Box sx={ButtonSx} onClick={onClick}>
      <Box sx={LabelSx}>
        <Icon sx={{ color: 'grey.400' }} />
        <Typography variant="body2" sx={TitleSx}>
          {label}
        </Typography>
      </Box>
      <Box>
        <Radio color="primary" checked={selected} />
      </Box>
    </Box>
  );
};

export interface ContactSelectionButtonProps {
  contactType: ContactType;
  /** The masked value of the contact, or the name of its type when the contact is not known. */
  label: string;
  onClick: () => void;
  selected: boolean;
}
